import { MessageBox } from 'element-ui'

const rootUrl = window.location.origin + '/'
// 检查间隔时间（毫秒），默认为1分钟一次
let interval = 60000
let timer = null
let lastModified = ''
/**
 * 检查网站是否有更新
 */
async function checkUpdate() {
  try {
    // 发送 HEAD 请求获取根路径的 Last-Modified 头
    const response = await fetch(rootUrl, {
      method: 'HEAD',
      // 添加随机参数避免缓存
      cache: 'no-store'
    })

    const currentModified = response.headers.get('Last-Modified')

    // 如果是第一次检查，记录当前的 Last-Modified
    if (!lastModified) {
      lastModified = currentModified
      return
    }

    if (currentModified && currentModified !== lastModified) {
      clearInterval(timer)
      timer = null
      MessageBox.confirm(
        'New version detected, refresh now?',
        'Update prompt',
        {
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }
      )
        .then(() => {
          window.location.reload()
        })
        .catch(() => {
          console.log('close')
          startTimer()
        })
    }
  } catch (error) {
    console.error('检查更新失败:', error)
  }
}

// 定时检查是否更新
function startTimer() {
  if (timer) {
    clearInterval(timer)
  }
  timer = setInterval(checkUpdate, interval)
}

// 当DOM加载完成后开始检查更新
document.addEventListener('DOMContentLoaded', () => {
  startTimer()
})
